import { Type, type Static } from "@sinclair/typebox";

export const StructureCostGroupSchema = Type.Object(
  {
    id: Type.String({
      minLength: 1,
      maxLength: 80,
      pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$",
    }),
    name: Type.String({ minLength: 1, maxLength: 160 }),
    description: Type.String({ maxLength: 2000 }),
    centerIds: Type.Array(Type.String({ format: "uuid" }), {
      maxItems: 500,
      uniqueItems: true,
    }),
  },
  { additionalProperties: false },
);
export const StructureCostPendingSplitSchema = Type.Object(
  {
    centerId: Type.String({ format: "uuid" }),
    note: Type.String({ minLength: 1, maxLength: 2000 }),
  },
  { additionalProperties: false },
);
export const StructureCostOrganizationSaveSchema = Type.Object(
  {
    operationId: Type.String({ format: "uuid" }),
    managementYear: Type.Integer({ minimum: 2027, maximum: 2200 }),
    version: Type.Union([Type.Integer({ minimum: 1 }), Type.Null()]),
    groups: Type.Array(StructureCostGroupSchema, { maxItems: 100 }),
    pendingSplits: Type.Array(StructureCostPendingSplitSchema, {
      maxItems: 500,
    }),
  },
  { additionalProperties: false },
);
export const StructureCostOrganizationQuerySchema = Type.Object(
  { managementYear: Type.Integer({ minimum: 2000, maximum: 2200 }) },
  { additionalProperties: false },
);

export type StructureCostGroup = Static<typeof StructureCostGroupSchema>;
export type StructureCostPendingSplit = Static<
  typeof StructureCostPendingSplitSchema
>;
export type StructureCostOrganizationSave = Static<
  typeof StructureCostOrganizationSaveSchema
>;
export interface StructureCostOrganization {
  managementYear: number;
  version: number | null;
  groups: StructureCostGroup[];
  pendingSplits: StructureCostPendingSplit[];
  updatedAt: string | null;
}
